import script from "./process-chain-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./process-chain-panel.vue?vue&type=script&setup=true&lang=ts"

import "./process-chain-panel.vue?vue&type=style&index=0&id=33028983&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33028983"]])

export default __exports__